import $ from 'jquery';
import 'magnific-popup/dist/jquery.magnific-popup';

const youTubePreviewV2Semantics = {
    'mainWrapClass': 'you-tube-preview-v2',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'youtubeHref': 'data-youtube-href',
    'mfpClass': 'you-tube-preview-v2-mfp'
};

/**
 * youTubePreviewV2 initializer
 */
$(function () {
    if ($(`.${youTubePreviewV2Semantics.mainWrapClass}`).length === 0) {
        return false;
    }

    let youTubePreviewV2 = new YouTubePreviewV2();

    /**
     * Checking other instances
     */
    $(`.${youTubePreviewV2Semantics.mainWrapClass}`).each((index, el) => {
        let objectElement = $(el);
        let isInitialized =
            (objectElement.attr(`${youTubePreviewV2Semantics.isInitializedAttribute}`) === 'true');
        if (!isInitialized) {
            youTubePreviewV2.registerInstance(objectElement);
            youTubePreviewV2.registerListeners(objectElement);
        }
    });

});

class YouTubePreviewV2 {
    // not install @babel/plugin-proposal-class-properties
    // init properties in constructor
    constructor() {
        this.pluginInstances = {};
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${youTubePreviewV2Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        el.show();
        try {
            el.attr(`${youTubePreviewV2Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = el;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el) {
        el.on(
            'click',
            function (e) {
                e.preventDefault();
                let $this = $(this);

                // Формируем ссылку на видео
                let youtubeUrl = $this.attr(`${youTubePreviewV2Semantics.youtubeHref}`);

                $.magnificPopup.open({
                    items: {
                        src: `<div class="mfp-iframe-scaler">
                            <iframe class="mfp-iframe"
                                    src="${youtubeUrl}"
                                    frameborder="0"
                                    allow="autoplay; encrypted-media"
                                    allowfullscreen>
                            </iframe>
                        </div>`,
                        type: 'iframe'
                    },
                    mainClass: youTubePreviewV2Semantics.mfpClass,
                    closeBtnInside: true,
                    removalDelay: 300,
                    callbacks: {
                        open: function () {
                            // console.log('YouTube popup opened');
                        },
                        close: function () {
                            // console.log('YouTube popup closed');
                        }
                    }
                });
            }
        )
    }
}